import React, { useContext } from 'react';
import { AgFinancingPhase2Status } from '@indigo-ag/schema';

import i18next from 'core/i18n';
import { Phase2Util } from 'shared';
import { UpdatePhase2StatusButtonDecisionModal } from '../UpdatePhase2StatusButtonDecisionModal/UpdatePhase2StatusButtonDecisionModal';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import { UserContext } from 'core/components/GateWay/GateWay';

export const DenyPhase2: React.FunctionComponent = () => {
  /**
   * Context
   */
  const { agFinance } = useContext(FinanceProcessContext);
  const { isCreditLead } = useContext(UserContext);

  if (!isCreditLead && Phase2Util.isWaitingCMApproval(agFinance?.phase2?.status)) {
    return null;
  }

  if (Phase2Util.isApproved(agFinance?.phase2?.status)) {
    return null;
  }

  return (
    <UpdatePhase2StatusButtonDecisionModal
      phase2TargetStatus={AgFinancingPhase2Status.DENIED}
      modalTitle={`${i18next.t('deny')} ${i18next.t('phase')} 2`}
      buttonVariant="secondary"
      buttonText={i18next.t('deny')}
      onSuccessMessage={i18next.t('phase2Denied')}
    />
  );
};
